import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// ****** Request Services ****** //
import logo from '../../../assets/images/comment.png';
import HomeRequest from '../../../services/HomeRequest/HomeRequest';
import UserRequest from '../../../services/UserRequrest/UserRequest';

// ****** SweetAlert2 ****** //
import Alert from '../../../utils/lazyAlert';


const initialState = {
  loading: false,
  places: [],
  place: {},
  place_weather: {},
  rate_count: 0,
  isCollection: {},
  similar_place: [],
  residences: [],
};

export const getAllPlaces = createAsyncThunk('places/getAllPlaces', async () => {
  try {
    const { data } = await HomeRequest.PlacesList();
    return data?.places;
  } catch (ex) {
    console.log(ex);
  }
});

export const getPlaceById = createAsyncThunk('places/getPlaceById', async (place_id) => {
  try {
    const { data } = await HomeRequest.GetPlace(place_id);

    return data;
  } catch (ex) {
    console.log(ex);
  }
});

export const addNewPlaceComment = createAsyncThunk(
  'places/addNewPlaceComment',
  async ({ place_id, comment }) => {
    try {
      const { status } = await UserRequest.AddPlaceComment(place_id, comment);
      if (status >= 200) {
        Alert.fire({
          title: '✅کامنت با موفقیت ثبت شد',
          html: `
    <div dir="rtl" class="text-center mt-2">
      <div class="mb-2">💬 از اینکه نظرت رو با ما به‌اشتراک گذاشتید، ممنونیم!</div>
      <div class="small text-muted">⏳ کامنتت بعد از بررسی در وب‌سایت منتشر میشود.</div>
    </div>
  `,
          imageUrl: logo,
          imageWidth: 80,
          confirmButtonText: 'باشه',
          showCancelButton: false,
          buttonsStyling: false,
          customClass: {
            popup: 'rounded-4 shadow-lg my-swal-popup',
            title: 'modal-title-wrap',
            htmlContainer: 'modal-text-wrap',
            icon: 'border-0 my-swal-icon',
            confirmButton: 'btnModal',
          },
          width: '30rem',
          backdrop: true,
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  },
);

export const placeSlice = createSlice({
  name: 'places',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllPlaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPlaces.fulfilled, (state, { payload }) => {
        state.places = payload;
        state.loading = false;
      })
      .addCase(getPlaceById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPlaceById.fulfilled, (state, { payload }) => {
        state.isCollection = payload?.isCollection;
        state.place = payload?.place;
        state.place_weather = payload?.weather;
        state.rate_count = Number(payload?.place_user) || 0;
        state.similar_place = payload?.similar_place;
        state.residences = payload?.place?.residences || payload?.residences || [];

        state.loading = false;
      });
  },
});

export default placeSlice.reducer;
